/* RESPONSIBLE TEAM: team-data-foundations */
import Model, { attr, hasMany } from '@ember-data/model';

export default class GithubIntegration extends Model {
  @attr() redirectUrl;
  @attr() nextPage;
  @attr('string') defaultGithubWebhookConfigId;
  @hasMany('github-repository') repositories;
}
